export const capitalizeFirstLetterOfEachWord = (str) => {
  if (!str) return "";

  const formattedStr = str.replace(/[-_]/g, " ");

  return formattedStr
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const convertToUpperCase = (str) => {
  if (!str) return "";

  return str.replace(/_/g, " ").toUpperCase();
};
